module.exports = __webpack_public_path__ + "static/img/AiphotoNo.47bbe295.png";